import type { Components, CssVarsTheme } from '@mui/material/styles';

const getBorderColor = (theme: CssVarsTheme) =>
  `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)`;

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiSelect']
>['styleOverrides'] = {
  root: ({ theme }) => {
    const borderColor = getBorderColor(theme);
    return {
      '&.Mui-readOnly:hover .MuiOutlinedInput-notchedOutline': {
        borderColor,
      },
      '&.Mui-readOnly:focus .MuiOutlinedInput-notchedOutline': {
        borderColor,
      },
      '&.Mui-readOnly:active .MuiOutlinedInput-notchedOutline': {
        borderColor,
      },
      '&.Mui-readOnly.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor,
      },
      '&.Mui-readOnly': {
        cursor: 'not-allowed',
      },
      '&.Mui-readOnly .MuiInputBase-root': {
        cursor: 'not-allowed',
      },
      '&.Mui-readOnly .MuiOutlinedInput-root': {
        cursor: 'not-allowed',
      },
      '&.Mui-readOnly .MuiSelect-select': {
        cursor: 'not-allowed',
      },
      '&.Mui-readOnly .MuiSelect-icon': {
        cursor: 'not-allowed',
        display: 'none',
      },
    };
  },
};

const MuiSelect: Components<CssVarsTheme>['MuiSelect'] = {
  styleOverrides,
};

export default MuiSelect;
